/**
 * Created by mh on 2017/8/6.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

const MetadataRowComponent = ({ metakey, metavalue }) => (
    <tr>
        <th>{metakey}</th>
        <td>{metavalue}</td>
    </tr>
);

MetadataRowComponent.propTypes = {
    metakey: PropTypes.string.isRequired,
    metavalue: PropTypes.string,
};

@observer
class MetadataTable extends React.Component {
    render() {
        const { metadata } = this.props;

        return (
            <div className="table-responsive">
                <table className="table table-sm table-striped table-delivermedia">
                    <tbody>
                        {metadata
                            ? Object.keys(metadata).map(key => (
                                <MetadataRowComponent
                                    metakey={key}
                                    metavalue={metadata[key]}
                                    key={key} />
                            ))
                            : (
                                <tr>
                                    <td>
                                        <FormattedMessage id="Assets.NoAssetsFound" defaultMessage="No assets found" />
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }
}

MetadataTable.propTypes = {
    metadata: PropTypes.object.isRequired,
};

export default injectIntl(MetadataTable);
